<template>
  	<div>
		<v-layout wrap>
			<v-flex xs12 mt-4>
				<app-table
					title="Encuestas"
					:name="name"
					:clean-search="cleanSearch"
					:filter-columns="false"
					:rows="rows"
					:columns="columns"
					:main-list="true"
					:items-quantity="totalItemsVisible"
					:items-total-quantity="totalItems"
					:current-page="currentPage"
					:last-page="lastPage"
					class="is-not-selectable no-main-list"
					@on-search-event="$emit('on-search', $event)"
					@on-page="$emit('on-page', $event)"
					@changeSort="$emit('changeSort', $event)"
					@changeColor="changeColor"
				>
					<template slot="rows" slot-scope="props">
						<td
							v-show="showRow(columns, 1)"
							:class="[
							'rowName is-not-selectable',
						]"
						:style="`border-left:2px solid ${props.row.numDiagnostics === 0 ? $appColors.error : 'transparent'}`"
						>{{ props.row.name }}</td>
						<td
							v-show="showRow(columns, 2)"
							:style="`color:${props.row.numDiagnostics === 0 ? $appColors.error : $appColors.info}`"
						>{{props.row.numDiagnostics}}</td>
						<td v-show="showRow(columns, 3)">{{props.row.numAnswered}}/{{props.row.numApplicants}}</td>
						<td v-show="showRow(columns, 4)">{{ props.row.createdAt | formatDate }}</td>
						<td v-show="showRow(columns, 5)" @click.stop="stopClick">
							<v-layout wrap align-center justify-start pl-2>
								<app-tooltip-button
									:img="`${$imageUrl}/copy-action.svg`"
									size="18"
									text="Duplicar"
									@click-icon="$emit('on-click', { action: 'clone', row: props.row })"
								/>
								<v-tooltip top>
									<v-switch
										class="switch-table ma-0 pt-2"
										color="success"
										slot="activator"
										v-model="props.row.state"
										:true-value="1"
										:false-value="0"
										hide-details
										@change="$emit('on-click', { action: 'state', row: props.row })"
									></v-switch>
									<span>{{ stateName(props.row) }}</span>
								</v-tooltip>
								<app-tooltip-button
									v-if="!!props.row.flagDelete"
									:img="`${$imageUrl}/delete-button.svg`"
									size="18"
									text="Eliminar"
									@click-icon="$emit('on-click', { action: 'delete', row: props.row })"
								/>
							</v-layout>
						</td>
					</template>
				</app-table>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import appHeader from '@/components/shared/app-header';
import appSidebar from '@/components/shared/app-sidebar';

function stateName({ state }) {
	return state ? 'Activa' : 'Inactiva';
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}

export default {
	name: 'survey-table',
	components: {
		appHeader,
		appSidebar,
	},
	methods: {
		stateName,
		changeColor,
	},
	props: {
		cleanSearch: {
			default: false,
			type: Boolean,
		},
		columns: {
			default: () => [],
			type: Array,
		},
		name: String,
		rows: {
			default: () => [],
			type: Array,
		},
		currentPage: [Number, String],
		lastPage: [Number, String],
		totalItems: [Number, String],
		totalItemsVisible: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
.rowName {
	width: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/survey-table.vue